// extracted by mini-css-extract-plugin
module.exports = {"textImageSectionWrapper":"textImageSection-module--textImageSectionWrapper--2_Ae4","textImageSection":"textImageSection-module--textImageSection--3ZT_V"};